'use strict';

/**
 * Model for a shop offer
 *
 * @category   Model
 * @module     shop
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var Model = require('base/Colido.Model');

var OfferModel = Model.extend({
    urlRoot: false, //use api from collection. Pass {collection: ...} as option when initializing model. See commandSendMessageToConversation()

    defaults: function(){ //use function, cause objects are passed by reference
        return {
            objectId: null, //Integer
            shopType: null, //Integer
            buyerId: null, //Integer
            sellerId: null, //Integer
            status: 'new', //String
            history: [], //Array of Objects with timestamps for status changes
            conversationId: null, //Integer
            conversationPostId: null, //Integer
            options: null,
        };
    },

    customAttributes: {
        // authorData: function() {
        //     var conversationUsers = this.collection.conversation.get('users');
        //     var authorData = _.findWhere(conversationUsers, {userId: this.get('userId')});

        //     return authorData;
        // },
        targetObjectLink: function() {
            var link = '';

            if (this.get('buyerId') === App.user.id) { //only buyer has targetObjectLink

                var offerOptions = this.get('options') || {};

                var catalogId = offerOptions.targetCatalogId;
                var objectId = offerOptions.targetObjectId;

                if (catalogId && objectId) {
                    var catalog = App.CollectionModule.catalogs.get(catalogId);

                    if (catalog) {
                        var object = catalog.objects.get(objectId);

                        if (object) {
                            var objectName = _.escape(object.get('properName'));

                            link = App.html.link({
                                url: '/catalogs/' + catalogId + '/show/' + objectId,
                                label: '»' + objectName + '«',
                            });
                        }
                    }
                }
            }

            return link;
        },

        targetCatalogLink: function() {
            var link = '';

            if (this.get('buyerId') === App.user.id) { //only buyer has targetCatalogLink
                var offerOptions = this.get('options') || {};

                var catalogId = offerOptions.targetCatalogId;

                if (catalogId) {
                    var catalog = App.CollectionModule.catalogs.get(catalogId);

                    if (catalog) {
                        var catalogName = catalog.get('name');

                        link = App.html.link({
                            url: '/catalogs/' + catalogId,
                            label: '»' + _.escape(catalogName) + '«',
                        });
                    }
                }
            }

            return link;
        },
    },
});

module.exports = OfferModel;